import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Banks\DashboardController::__invoke
* @see app/Http/Controllers/Banks/DashboardController.php:19
* @route '//bank.finesthub.de/dashboard'
*/
const DashboardController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DashboardController.url(options),
    method: 'get',
})

DashboardController.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\DashboardController::__invoke
* @see app/Http/Controllers/Banks/DashboardController.php:19
* @route '//bank.finesthub.de/dashboard'
*/
DashboardController.url = (options?: RouteQueryOptions) => {
    return DashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\DashboardController::__invoke
* @see app/Http/Controllers/Banks/DashboardController.php:19
* @route '//bank.finesthub.de/dashboard'
*/
DashboardController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DashboardController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\DashboardController::__invoke
* @see app/Http/Controllers/Banks/DashboardController.php:19
* @route '//bank.finesthub.de/dashboard'
*/
DashboardController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: DashboardController.url(options),
    method: 'head',
})

export default DashboardController